<template>
	<Container>
		<Title>
			{{ $t('news') }}
		</Title>

		<div class="newsFiltersGrid mb-8">
			<div class="newsCategory">
				<div class="cursor-pointer flex items-center">
					<img src="@/assets/img/categorias.svg" alt="Categorias" />
					<select
						v-model="category_id"
						@change="onChangeCategory"
						class="
							text-secondary
							px-2
							ml-1
							border-solid
							border-b
							border-t-0
							border-r-0
							border-l-0
							border-primary
							flex
							items-center
						"
					>
						<option value="">{{ $t('categorias') }}</option>
						<option
							v-for="category in news_categories"
							:value="category.id"
							v-bind:key="category.id"
						>
							{{ category.category_name }}
						</option>
					</select>
				</div>
			</div>

			<div class="newsSearch flex">
				<img src="@/assets/img/buscar.svg" />
				<div
					class="
						px-2
						ml-1
						border-solid
						border-b
						border-t-0
						border-r-0
						border-l-0
						border-primary
						flex
						items-center
						w-full
					"
				>
					<input
						class="text-secondary w-full border-none outline-none"
						v-model="search"
						@keyup="onChangeSearch"
						v-bind:placeholder="$t('search')"
					/>
				</div>
			</div>
		</div>

		<div class="grid" v-if="news">
			<Card v-for="(newsItem, newsIndex) in news" v-bind:key="newsIndex">
				<div class="newGrid">
					<div>
						<router-link class="no-underline" :to="'noticias/' + newsItem.id">
							<h2 class="font-bold text-lg m-0 no-underline hover:underline">
								{{ newsItem.title }}
							</h2>
						</router-link>
						<span class="text-secondary italic text-sm">{{
							newsItem.category.category
						}}</span>
					</div>
					<div
						class="
							object-cover
							overflow-hidden
							rounded-sm
							flex
							justify-center
							mt-2
						"
					>
						<div v-if="newsItem.image">
							<img :src="newsItem.image" class="imgNews" />
						</div>
						<div v-else>
							<img :src="newsItem.category.image" class="imgNews" />
						</div>
					</div>
					<div
						clasS="text-secondary text-sm my-3 text-justify"
						v-html="newsItem.description"
					></div>
					<div class="flex justify-between self-end">
						<div class="text-sm">
							{{ newsItem.publishing_date | moment('DD/MM/YYYY') }}
						</div>
						<router-link
							class="font-normal no-underline hover:underline text-sm"
							:to="'noticias/' + newsItem.id"
							>{{ $t('read_more') }}</router-link
						>
					</div>
				</div>
			</Card>
		</div>
		<div v-else>{{ $t('not_found_news') }}.</div>
	</Container>
</template>

<script>
import gql from 'graphql-tag'

export default {
	apollo: {
		news_categories: {
			query: gql`
				query ($country_id: bigint!) {
					news_categories(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
					) {
						id
						category_name
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			}
		},
		news: {
			query: gql`
				query ($country_id: bigint!, $category_id: bigint, $search: String) {
					news(
						where: {
							country_id: { _eq: $country_id }
							category_id: { _eq: $category_id }
							active: { _eq: true }
							title: { _ilike: $search }
						}
						order_by: { publishing_date: desc }
					) {
						id
						title
						image {
							url
						}
						news_category {
							category_name
						}
						description
						publishing_date
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.news.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(
									1
							  )}&width=300`
							: undefined

					return {
						id: item.id,
						title: item.title,
						image: image,
						category: item.news_category.category_name,
						description: item.description,
						publishing_date: item.publishing_date
					}
				})
			}
		}
	},
	data() {
		return {
			country_id: this.$store.state.login.user.country_id,
			category_id: '',
			search: ''
		}
	},
	methods: {
		onChangeCategory() {
			this.$apollo.queries.news.refetch({
				category_id: isNaN(parseInt(this.category_id))
					? undefined
					: this.category_id
			})
		},
		onChangeSearch() {
			this.$apollo.queries.news.refetch({
				search: `%${this.search}%`
			})
		}
	}
}
</script>

<style scoped>
.newGrid {
	height: 100%;
	display: grid;
}

.newsCategory {
	grid-area: category;
}
.newsSearch {
	grid-area: search;
}

.newsFiltersGrid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-areas: 'category search search';
}
.imgNews {
	max-height: 200px;
}
@media (max-width: 768px) {
	.newsFiltersGrid {
		display: block;
	}
	.newsFiltersGrid div {
		margin: 5px;
	}
}
</style>
